var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "rating__star-icon-inner",
    d: "M26.9017 14.8901C27.803 14.1215 27.3294 12.6469 26.1491 12.5469L20.5416 12.0719C20.0521 12.0304 19.6251 11.7231 19.4302 11.2721L17.2249 6.16779C16.7613 5.09479 15.2397 5.09521 14.7766 6.16846L12.57 11.2835C12.3751 11.7354 11.947 12.0431 11.4565 12.084L5.8614 12.5504C4.67949 12.6489 4.20479 14.1258 5.10797 14.8945L9.32497 18.4836C9.70651 18.8083 9.8738 19.3195 9.75806 19.807L8.48611 25.1636C8.2142 26.3087 9.45107 27.2188 10.4634 26.6185L15.3199 23.7388C15.7392 23.4901 16.2608 23.4901 16.6801 23.7388L21.5417 26.6216C22.5533 27.2214 23.7896 26.3131 23.5194 25.1685L22.2537 19.8052C22.1389 19.3187 22.3059 18.8087 22.6863 18.4844L26.9017 14.8901Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "rating__star-icon-outline",
    fill: "none",
    strokeWidth: 1.25,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    vectorEffect: "non-scaling-stroke",
    d: "M26.9017 14.8901C27.803 14.1215 27.3294 12.6469 26.1491 12.5469L20.5416 12.0719C20.0521 12.0304 19.6251 11.7231 19.4302 11.2721L17.2249 6.16779C16.7613 5.09479 15.2397 5.09521 14.7766 6.16846L12.57 11.2835C12.3751 11.7354 11.947 12.0431 11.4565 12.084L5.8614 12.5504C4.67949 12.6489 4.20479 14.1258 5.10797 14.8945L9.32497 18.4836C9.70651 18.8083 9.8738 19.3195 9.75806 19.807L8.48611 25.1636C8.2142 26.3087 9.45107 27.2188 10.4634 26.6185L15.3199 23.7388C15.7392 23.4901 16.2608 23.4901 16.6801 23.7388L21.5417 26.6216C22.5533 27.2214 23.7896 26.3131 23.5194 25.1685L22.2537 19.8052C22.1389 19.3187 22.3059 18.8087 22.6863 18.4844L26.9017 14.8901Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.40532af4a3b3e5e9a1efbd6a49dee889.svg";
export { ForwardRef as ReactComponent };